import { render, staticRenderFns } from "./melhorCompra.vue?vue&type=template&id=25cb79ea"
import script from "./melhorCompra.ts?vue&type=script&lang=js&external"
export * from "./melhorCompra.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25cb79ea')) {
      api.createRecord('25cb79ea', component.options)
    } else {
      api.reload('25cb79ea', component.options)
    }
    module.hot.accept("./melhorCompra.vue?vue&type=template&id=25cb79ea", function () {
      api.rerender('25cb79ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/compras/melhorCompra.vue"
export default component.exports